/* eslint-disable react-hooks/exhaustive-deps */


import React, { useEffect, useState } from "react";
import Footer from "../../Layout/Footer";
import Header from "../../Layout/Header";
import { FadeLoader } from "react-spinners";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getExerciseDetail, getProgram } from "../../../actions/user_program";
import ExerciseBreadcrumb from "./ExerciseBreadcrumb";
import ExerciseContainer from "./ExerciseContainer";
import TimerWeek1 from "../AssessmentTimer/TimerWeek1";
import { clearActiveExercise, selectActiveExercise } from "../../../actions/user_active_exercise";
import { setUserActiveDay } from "../../../actions/user_active_day";

const Exercise = ({
  program,
  getProgram,
  getExerciseDetail,
  exercises,
  activeExercise,
  selectActiveExercise,
  clearActiveExercise,
  setUserActiveDay,
  activeDayId,
}) => {
  // TODO: Remove this line
  const activeDayName = localStorage.getItem("activeDayName") || null;
  const [nextExerciseId, setNextExerciseId] = useState(null);

  const [filteredExercises, setFilteredExercises] = useState(null); // TODO: Figure out what is this!

  useEffect(() => {
    if (!program) {
      getProgram();
    }

    return () => {
      clearActiveExercise();
    }
  }, []);

  useEffect(() => {
    const topElement = document.querySelector(".welcome_001"); // Replace 'top-element' with the actual ID of your top element

    if (topElement) {
      topElement.scrollIntoView({
        behavior: "smooth",
        block: "start", // Scroll to the top of the element
      });
    }
  }, []);

  useEffect(() => {
    if (activeDayId !== null) {
      setUserActiveDay(activeDayId)
    }
  }, [activeDayId, setUserActiveDay]);

  useEffect(() => {
    if (!exercises || exercises.length === 0) return;

    let activeEx;
    let nextIndex;
    
    if (activeExercise) {
      activeEx = exercises.find((item) => item.id === activeExercise.id);
      nextIndex = exercises.findIndex((item) => item.id === activeExercise.id) + 1;
    } else {
      activeEx = exercises.find((item) => item.is_started === true);
      nextIndex = exercises.findIndex((item) => item.is_started === true) + 1;

      selectActiveExercise(activeEx?.id || exercises[0].id);
    }
    
    // Filter exercises
    const filteredRecords = exercises
      .filter(
        (exercise) =>
          exercise?.exerciseLevel?.suggested_weight_lbs &&
          exercise?.exerciseLevel?.metric === 10
      )
      .map((item) => item.id);

    setFilteredExercises(filteredRecords);    
    setNextExerciseId(exercises[nextIndex]?.id || null);
  }, [activeExercise, exercises]);

  const setActiveExerciseFunc = (exerciseId) => {
    selectActiveExercise(exerciseId);
  };

  const setRepeatCircuitFunc = () => {
    selectActiveExercise(exercises[0].id);
  };

  if (!program || !activeExercise) {
    return (
      <section className="welcome_001">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-lg-6 col-md-6 m-auto">
              <div className="box_banner_inner text-center mx-auto">
                <FadeLoader color={"#FB1417"} height={10} />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <Header />
      {/* <ExerciseProgressBar
        exercises={exercises ? exercises : []}
        activeExercise={activeExercise}
      /> */}
      <TimerWeek1
        exercises={exercises ? exercises : []}
        activeExercise={activeExercise.id}
        setActiveExercise={setActiveExerciseFunc}
      />

      <ExerciseBreadcrumb activeDay={activeDayName} program={program} />
      <ExerciseContainer
        activeDay={activeDayId}
        program={program}
        nextExerciseId={nextExerciseId}
        setActiveExercise={setActiveExerciseFunc}
        setRepeatCircuit={setRepeatCircuitFunc}
        filteredExercises={filteredExercises}
      />
      <Footer />
    </>
  );
};

Exercise.propTypes = {
  program: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  exercises: state.programReducer.exercises,
  program: state.programReducer.program,
  activeExercise: state.userActiveExerciseReducer.exercise,
  activeDayId: state.userActiveDayReducer.activeDayId,
});

export default connect(mapStateToProps, {
  getProgram,
  getExerciseDetail,
  selectActiveExercise,
  clearActiveExercise,
  setUserActiveDay,
})(Exercise);
